import { MenuItem } from '@mui/material';
import RoundedSelect from 'common/components/RoundedSelect';
import { transformKey } from 'common/features/extraFields/ExtraFieldsRender';
import { containsText } from 'common/utils/utils';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { fetchProductFieldValues } from 'redux/slices/productSlice';

const SelectByExtraField = ({ field, customMenuProps, onSubmit, fullWidth, fieldParamId, size = 'small' }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [params] = useSearchParams();
    const fieldId = fieldParamId || params.get(`${field}`) || 'all';
    const [allOptions, setAllOptions] = useState([]);
    const [options, setOptions] = useState([]);
    const [open, setOpen] = useState(false);
    const fieldName = transformKey(field);

    const loadFieldValues = useCallback(() => {
        dispatch(
            fetchProductFieldValues({
                field,
                onSuccess: (data) => setAllOptions(data),
            }),
        );
    }, [field, dispatch]);

    useEffect(() => {
        loadFieldValues();
    }, [loadFieldValues]);

    const onOptionsFilter = (text) => {
        const newOptions = allOptions.filter((option) => containsText(option, text));
        setOptions(newOptions);
    };

    useEffect(() => {
        if (!open) {
            setOptions([...allOptions]);
        }
    }, [allOptions, open]);

    if (allOptions.length === 0 || allOptions[0] === null) {
        return null;
    }

    return (
        <RoundedSelect
            bold={true}
            value={fieldId}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            onChange={(e) => {
                onSubmit(e, field);
            }}
            size={size}
            search={allOptions.length > 10}
            searchPlaceholder={t('iCalendar.filter.searchFields', { field: fieldName })}
            onSearchFilter={onOptionsFilter}
            customMenuProps={customMenuProps}
            fullWidth={fullWidth}
        >
            <MenuItem value="all">{t('iCalendar.filter.allFields', { field: fieldName })}</MenuItem>

            {options?.map((tag) => (
                <MenuItem key={tag} value={tag}>
                    {transformKey(tag)}
                </MenuItem>
            ))}
        </RoundedSelect>
    );
};

export default SelectByExtraField;
